import { ComponentPropsWithRef, ReactNode } from "react";
import * as styles from "./style";

export interface HeroProps extends ComponentPropsWithRef<"div"> {
  children: ReactNode;
}

export const Hero = ({ children, ...props }: HeroProps) => {
  return (
    <div css={styles.container} {...props}>
      {children}
    </div>
  );
};
